<template>
  <div class="content-max-width mx-auto">
    <div id="correspondence-box" class="mt-3" v-if="!isTeacherPage">
      <h4 class="mx-auto">Комментарии</h4>
      <b-card
        v-for="message in content.contentObject.changeHistory"
        :key="message.id"
        no-body
        :border-variant="messageClass(getRoles(message.user))"
        footer-text-variant="black"
        class="overflow-hidden mb-3 text-justify shadow-sm mx-auto"
        :footer-bg-variant="messageClass(getRoles(message.user))"
        :footer-border-variant="messageClass(getRoles(message.user))"
        >
        <b-row no-gutters>
          <div class="mr-1" style="right: 0; top: 0; position: absolute">
            {{ (new Date(message.createdAt)).toLocaleString() }}
          </div>
          <b-col md="3" style="min-width: 100px;max-width: 100px">
            <b-card-img
              class="border rounded-circle m-2"
              width="100" height="100"
              :src="getMessageSrc(message)">
            </b-card-img>
          </b-col>
          <b-col md="9">
            <b-card-body
              :title="getMessageTitle(message)"
              :sub-title="getRoles(message.user)"
              >
            </b-card-body>
          </b-col>
        </b-row>
        <b-card-footer class="changeHistory_messageBody">
          <p>
            {{ (message.text) ? message.text : 'Комментарий не был оставлен' }}
          </p>
          <p v-if="message.file">
            <strong>Заключение: </strong>
            <a target="_blank" :href="'/api/files/' + message.file.physicalName">
              {{ message.file.name }}
            </a>
          </p>
        </b-card-footer>
      </b-card>
      <b-alert
        v-if="!content.contentObject.changeHistory || !content.contentObject.changeHistory.length"
        show variant="info" class="mx-auto">
        Комментарии отсутствуют
      </b-alert>
    </div>

    <!-- Форма с textarea для написания комментария спецу по режиму контент-менеджером -->
    <b-form
      @submit="onSubmit"
      @reset="onRejectContent"
      class="mx-auto w-50"
      v-if="!isTeacherPage &&
        ((isContentManagerPage && isDraft && isEditMode) ||
        $route.params.type === 'await')"
    >
      <b-form-textarea
        id="textarea-comment"
        v-model="form.comment"
        placeholder="Введите комментарий"
        rows="8"
        ></b-form-textarea>
      <div v-if="$route.params.type !== 'await'">
        <p v-if="!conclusionFile" style="color: red" class="mt-3">
        Файл с заключением не прикреплен
        </p>
        <p v-else class="mt-3">
        {{ conclusionFile.name }}
        <span @click="deleteConclusionFile" class="conclusionFile_deleteIcon">
          <em class="fas fa-times"></em>
        </span>
        </p>
        <p>
        <a target="_blank" :href="expertExampleLink">Шаблон экспертного заключения</a>
        </p>
        <b-button
          class="mt-3"
          variant="outline-primary"
          v-b-tooltip.hover
          title="Заключение должно быть в формате .pdf"
          @click="addConclusionFileClicked" block>
          Прикрепить файл с заключением
        </b-button>
      </div>
      <b-form-file
        @change='loadConclusion($event.target)'
        plain
        hidden
        id='conclusionFileInput'
        accept=".pdf"
        ref="conclusionFile">
      </b-form-file>
      <div v-if="isContentManagerPage">
        <b-button v-b-tooltip.hover
                  title="Публикация будет отправлена на проверку специалисту по режиму"
                  class="mt-3" variant="outline-primary"
                  v-b-modal.confirm-submit-modal
                  block>
          Отправить на проверку
        </b-button>
      </div>
      <div v-else-if="$route.params.type === 'await'">
        <div class="mt-3 d-flex">
          <b-button variant="primary" type="submit" class="mr-3 w-100">
            Подтвердить
          </b-button>
          <div
            v-b-tooltip.hover
            title="Для отклонения необходимо ввести комментарий"
            class="w-100"
            v-if="!(form.comment && form.comment.length)"
          >
            <b-button
                      class="w-100"
                      variant="outline-primary"
                      disabled="true"
                      type="reset"
                      >
              Отклонить
            </b-button>
          </div>
          <div v-else class="w-100">
            <b-button
              class="w-100"
              variant="outline-primary"
              type="reset"
              >
              Отклонить
            </b-button>
          </div>
      </div>
      </div>
    </b-form>
    <b-modal ref="confirm-submit-modal" id="confirm-submit-modal"
      title="Подтверждение" cancel-title="Отмена"
      cancel-variant="outline-primary" @ok="onSubmit"
      >
      <p v-if="!isTeacherPage">
        Редактирование контента будет недоступно до проверки специалистом по режиму. Продолжить?
      </p>
      <p v-else>
        Опубликовать данное мероприятие?
      </p>
    </b-modal>
    <div v-if="isTeacherPage && isEditMode" class="mx-auto w-50">
      <b-button v-b-tooltip.hover
                  title="Публикация мероприятия"
                  class="mt-3" variant="outline-primary"
                  v-b-modal.confirm-submit-modal
                  block>
          Опубликовать
        </b-button>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapGetters, mapActions } from 'vuex'
import UserMixin from '@/components/helpers/mixins/user-mixin'
import notsApi from '@/api/notifications'
import ContentApi from '@/api/content'
import { roles, roleTranslates } from '@/config/roles'
import { statusFilters } from '@/config/content/statuses'
import { typeTranslates } from '@/config/content/types'

export default {
  name: 'ContentAccept',
  mixins: [UserMixin],
  props: {
    beforeSendToVerification: {
      type: Function
    }
  },
  data() {
    return {
      conclusionFile: null,
      defaultAvatar: '/images/account/default.jpg',
      form: {
        comment: ''
      }
    }
  },
  mounted() {
    if (!this.expertExampleLink) {
      this.fetchExpertExampleLink()
    }
  },
  methods: {
    ...mapActions({
      fetchExpertExampleLink: 'dicts/fetchExpertExampleLink',
      sendContentToVerification: 'content/sendContentToVerification',
      sendResultOfVerification: 'content/sendResultOfVerification',
      pushToasts: 'toasts/pushToasts'
    }),
    ...mapMutations({}),
    getMessageSrc(message) {
      if (message.user && message.user.avatarFile) {
        return `/api/files/${message.user.avatarFile.physicalName}`
      }
      return this.defaultAvatar
    },
    getRoles(user) {
      const userRoles = user ? user.roles : []
      let stringRoles = ''
      userRoles.forEach((role) => {
        stringRoles += `${this.$_userMixin_roleTranslate(role.title || role)}, `
      })
      stringRoles = stringRoles.substring(0, stringRoles.length - 2)
      return stringRoles
    },
    getMessageTitle(message) {
      return message.user
        ? `${message.user.surname} ${message.user.name[0]}.${
          message.user.midname ? `${message.user.midname[0]}.` : ''}`
        : 'Сотрудник'
    },
    messageClass(data) {
      return data.includes(roleTranslates[roles.verification]) ? 'info' : 'secondary'
    },
    loadConclusion(input) {
      if (input.files && input.files[0]) {
        const [loadedFile] = input.files
        if (loadedFile.type.split('/')[1] !== 'pdf') {
          this.pushToasts({
            title: 'Уведомление',
            error: true,
            message: 'Неверный формат файла с заключением!',
            time: 3
          })
        } else {
          [this.conclusionFile] = input.files
        }
      }
    },
    deleteConclusionFile() {
      this.$refs.conclusionFile.$refs.input.value = ''
      this.conclusionFile = null
    },
    async onSubmit(evt) {
      if (evt) {
        evt.preventDefault()
      }
      if (this.isContentManagerPage) {
        this.onSendToVerification().then(() => {
          this.$router.push('./')
        })
      } else if (this.isTeacherPage) {
        await this.beforeSendToVerification()
        await ContentApi.sendContentToVerificationByTeacher(this.content.contentObject.id)
        this.$router.push('./')
      } else if (this.$route.params.type === 'await') {
        this.onAcceptContent()
      }
    },
    onAcceptContent() {
      // this.isResultOfVerSending = true
      this.sendResultOfVerification({
        id: this.$route.params.id,
        status: statusFilters.accepted,
        text: this.form.comment
      }).then(() => {
        this.$router.push('/content/await')
      })
      let text = `<p>${this.content.contentObject.type}`
      if (this.content.contentObject.type === typeTranslates.news) {
        text += ` <strong class="notification__link-success">"${this.contentTitle}`
        text += '"</strong> была принята к публикации</p>'
      } else if (this.content.contentObject.type === typeTranslates.event) {
        text += ` <strong class="notification__link-success">"${this.contentTitle}`
        text += '"</strong> было принято к публикации</p>'
      } else if (this.content.contentObject.type === typeTranslates.class) {
        text = `<p>Обновление информации ГП-класса <strong class="notification__link-success"> ${this.contentTitle} </strong> подтверждено</p>`
      } else if (this.content.contentObject.type === typeTranslates.partner) {
        text = `<p>Обновление информации вуза-партнера <strong class="notification__link-success"> ${this.contentTitle} </strong> подтверждено</p>`
      } else if (this.content.contentObject.type === typeTranslates.spo) {
        text = `<p>Обновление информации СПО <strong class="notification__link-success"> ${this.contentTitle} </strong> подтверждено</p>`
      } else if (this.content.contentObject.type === typeTranslates.course) {
        text = `<p>Курс <strong class="notification__link-success"> ${this.contentTitle} </strong> одобрен к публикации</p>`
      } else if (this.content.contentObject.type === typeTranslates.training) {
        text = `<p>Тренажер <strong class="notification__link-success"> ${this.contentTitle} </strong> одобрен к публикации</p>`
      }
      notsApi.sendNote(text, this.content.contentObject.updaterId)
    },
    onRejectContent() {
      // this.isResultOfVerSending = true
      this.sendResultOfVerification({
        id: this.$route.params.id,
        status: statusFilters.rejected,
        text: this.form.comment
      }).then(() => {
        this.$router.push('/content/await')
      })
      let text = `<p>${this.content.contentObject.type}`
      if (this.content.contentObject.type === typeTranslates.news) {
        text += ` <strong class="notification__link-danger">"${this.contentTitle}`
        text += '"</strong> была отклонена</p>'
      } else if (this.content.contentObject.type === typeTranslates.event) {
        text += ` <strong class="notification__link-danger">"${this.contentTitle}`
        text += '"</strong> было отклонено</p>'
      } else if (this.content.contentObject.type === typeTranslates.class) {
        text = `<p>Обновление информации ГП-класса <strong class="notification__link-danger"> ${this.contentTitle} </strong> отклонено</p>`
      } else if (this.content.contentObject.type === typeTranslates.partner) {
        text = `<p>Обновление информации вуза-партнера <strong class="notification__link-danger"> ${this.contentTitle} </strong> отклонено</p>`
      } else if (this.content.contentObject.type === typeTranslates.spo) {
        text = `<p>Обновление информации СПО <strong class="notification__link-danger"> ${this.contentTitle} </strong> отклонено</p>`
      } else if (this.content.contentObject.type === typeTranslates.course) {
        text = `<p>Курс <strong class="notification__link-danger"> ${this.contentTitle} </strong> отклонен к публикации</p>`
      } else if (this.content.contentObject.type === typeTranslates.training) {
        text = `<p>Тренажер <strong class="notification__link-danger"> ${this.contentTitle} </strong> отклонен к публикации</p>`
      }
      notsApi.sendNote(text, this.content.contentObject.updaterId)
    },
    async onSendToVerification() {
      await this.beforeSendToVerification()
      await this.sendContentToVerification({
        id: this.content.contentObject.id,
        text: this.form.comment,
        file: this.conclusionFile
      })
      this.$router.push('./')
    },
    addConclusionFileClicked() {
      document.getElementById('conclusionFileInput').click()
    }
  },
  computed: {
    ...mapGetters({
      content: 'content/getContent',
      expertExampleLink: 'dicts/getExpertExampleLink',
      isEditMode: 'contentManager/isEditMode'
    }),
    isContentManagerPage() {
      return (
        !this.$route.path.includes('/class/content/events')
        && (
          this.$route.path.includes('/content/events')
          || this.$route.path.includes('/content/news')
          || this.$route.path.includes('/content/partners')
          || this.$route.path.includes('/content/classes')
          || this.$route.path.includes('/content/courses')
          || this.$route.path.includes('/content/training')
        )
      )
    },
    isTeacherPage() {
      return (
        this.$route.path.includes('/class/content/events')
      )
    },
    contentTitle() {
      return this.content.contentObject.title
    },
    isDraft() {
      if (this.content.contentObject) {
        return this.content.contentObject.status === statusFilters.draft
          || this.content.contentObject.status === statusFilters.rejected
      }
      return false
    }
  }
}
</script>

<style scoped>
.changeHistory_messageBody {
  background-color: white !important;
}
</style>
